import React, { useState } from 'react';
import { UserContext } from './UserContext';
import { User } from 'src/types/models/user';

export function ContextualisedUser({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(null);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
}
